<template>
  <div v-if='proposals.length > 0'>
    <el-card  hit shadow class="box-card">
      <div slot="header" class="clearfix">
        <el-switch v-model="showComments" style="float: right; padding: 3px 0"
          active-text="Έμφάνιση" inactive-text="Αποκρυψη">
        </el-switch>
        <span>Εισηγήσεις</span>
      </div>
      <div class="text item" v-if='showComments'>
        <el-table :data="proposals" style="width: 100%">
          <el-table-column label="Ονοματεπώνυμο" width="270">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ρόλος" width="200">
            <template slot-scope="scope">
              <span>{{ translate(scope.row.role) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ημερομηνία" width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.dateCompleted ? scope.row.dateCompleted.substring(0, 16) : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Εισήγηση">
            <template slot-scope="scope">
              <el-popover trigger="click" placement="top-start"
                title= "Εισήγηση: ">
                <span slot="reference" style="color: blue">Πατήστε για άνοιγμα</span>
                <span v-html="scope.row.proposal"></span>
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column fixed="right" label="Ενέργειες" width="200">
              <template slot-scope="scope">
                <el-button @click="dialogOpen = true, openDialog(scope.$index, scope.row)" type="text" size="small">Προβολή</el-button>
              </template>
            </el-table-column> -->
        </el-table>
        <!-- <el-dialog title="Προβολή" :visible.sync="dialogOpen">
            <el-card @closeDialogEvent='closeDialogEvent'>
                {{ prop }}
            </el-card>
        </el-dialog> -->
      </div>
    </el-card>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import dictionaryForMenu from '../../store/dictionaryForMenu'

export default {
  components: {
    dictionaryForMenu
  },
  data () {
    return {
      showComments: true,
      dialogOpen: false,
      prop: ''
    }
  },
  methods: {
    openDialog (index, row) {
      this.prop = row.proposal
    },
    closeDialogEvent () {
      this.dialogOpen = false
    },
    // Use a translate method to translate the queues to the greek names Προέλεγχος, Ειδικός...
    translate (term) {
      return dictionaryForMenu[term] ? dictionaryForMenu[term] : ''
    }
  },
  computed: {
    ...mapState([
      'proposals'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Proposals.vue